import { create } from 'zustand';
export const useHomeStore = create<{
  menuOpen: boolean;
  logoReplay: number;
  /** -1: automatic; 0..1600: frozen desktop-equivalent timeline for review. */
  motionFrame: number;
  motionToolsOpen: boolean;
  compareOriginal: boolean;
  setMotionFrame: (value: number) => void;
  toggleMotionTools: () => void;
  toggleComparison: () => void;
  setMenuOpen: (value: boolean) => void;
  showStaticLogo: () => void;
  replayLogo: () => void;
}>((set) => ({
  menuOpen: false,
  logoReplay: 0,
  motionFrame: -1,
  motionToolsOpen: false,
  compareOriginal: false,
  setMotionFrame: (motionFrame) => set({ motionFrame: Math.max(0, Math.min(1600, motionFrame)), compareOriginal: false }),
  toggleMotionTools: () => set(state => ({ motionToolsOpen: !state.motionToolsOpen })),
  toggleComparison: () => set(state => ({ compareOriginal: !state.compareOriginal, motionFrame: 1600 })),
  setMenuOpen: (menuOpen) => set({ menuOpen }),
  showStaticLogo: () => set({ motionFrame: 1600 }),
  replayLogo: () => set((state) => ({ motionFrame: -1, logoReplay: state.logoReplay + 1 })),
}));
